import React from "react";
import AdminLogo from "components/img/AdminLogo";
import { MobileHeaderWrapper, MobileHeaderLogoWrapper, MobilePageWrapper } from "./styled";

const MobileCard = ({
  children,
}: any) =>{
  return (
    <MobilePageWrapper>
    <MobileHeaderWrapper>
        <MobileHeaderLogoWrapper>
            <AdminLogo alt={process.env.REACT_APP_SERVICE} customStyles={{width: "150px", margin: "10px 0"}}/>
        </MobileHeaderLogoWrapper>
    </MobileHeaderWrapper>
    {children}
    </MobilePageWrapper>
  )
}

export default MobileCard;